// Bridge between the dedicated-login App shell (Elixir LiveView) and the
// React island (same-origin iframe of the App bundle).
//
// Downstream — realtime relay: the LiveView subscribes to the App's data
// topics server-side and pushes "shell-realtime" events; we forward them into
// the island via postMessage. The SDK inside the bundle only dispatches them
// while its own websocket is down, so nothing arrives twice.
//
// Upstream — crash watchdog: the bundle's ErrorBoundary posts
// `seiva:fix-error` to the parent window (a contract that predates the shell);
// we forward it to the LiveView, which reloads the island once
// (supervisor-style self-healing) and surfaces a notice if it keeps crashing.
const AppShellIsland = {
  mounted() {
    this.onMessage = (e) => {
      if (e.origin !== window.location.origin) return
      const data = e.data
      if (data && data.type === "seiva:fix-error") {
        this.pushEvent("island_crashed", {message: data.message || ""})
      }
    }
    window.addEventListener("message", this.onMessage)

    this.handleEvent("shell-realtime", ({event, payload}) => {
      const frame = this.el
      if (frame && frame.contentWindow) {
        frame.contentWindow.postMessage(
          {type: "seiva:shell:realtime", event, payload},
          window.location.origin
        )
      }
    })
  },

  destroyed() {
    window.removeEventListener("message", this.onMessage)
  },
}

export default AppShellIsland
